export const BASE_URL = 'BASE_URL';
export const SIGN_IN = 'SIGN_IN';
export const SIGN_OUT = 'SIGN_OUT';
export const SESSION_EXPIRED = 'SESSION_EXPIRED';
export const UPDATE_USER_INFO = 'UPDATE_USER_INFO';
export const TOKEN_REFRESHING = 'TOKEN_REFRESHING';
export const UPDATE_CALC_GARANTIES = 'UPDATE_CALC_GARANTIES';
export const TOKEN_UPDATED = 'TOKEN_UPDATED';
export const BACK_TO_DEVIS_ENABLE = 'BACK_TO_DEVIS_ENABLE';
export const BACK_TO_DEVIS_DISABLE = 'BACK_TO_DEVIS_DISABLE';
export const UPDATE_DRIVING_SCHOOL_INFO = 'UPDATE_DRIVING_SCHOOL_INFO';
export const UPDATE_REPRESENTATIVE_INFO = 'UPDATE_REPRESENTATIVE_INFO';
export const UPDATE_REPRESENTATIVE_VERIFICATION_DOCUMENTS = 'UPDATE_REPRESENTATIVE_VERIFICATION_DOCUMENTS';



// WEBPACK FOOTER //
// ./src/store/mutation-types.js